import React from 'react';
import Logo from './Logo';
import { COMPANY } from '../mock';
import { Phone, Mail, MapPin, Linkedin, Facebook, Instagram, Youtube } from 'lucide-react';

export default function Footer() {
  return (
    <footer id="contact" className="bg-orange-950 text-orange-50 mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Logo variant="light" />
          <p className="mt-5 text-sm text-orange-200/80 max-w-sm">End-to-end solar rooftop EPC, AMC and financing solutions for residential, commercial and industrial customers across Karnataka.</p>
          <div className="flex gap-3 mt-6">
            {[Linkedin, Facebook, Instagram, Youtube].map((I, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-orange-900 hover:bg-amber-500 hover:text-orange-950 flex items-center justify-center transition-colors">
                <I className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-sm font-bold mb-4 text-white">Solutions</h4>
          <ul className="space-y-2 text-sm text-orange-200/80">
            <li>Residential Solar</li><li>Commercial Solar</li><li>Industrial Plants</li><li>AMC Services</li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold mb-4 text-white">Company</h4>
          <ul className="space-y-2 text-sm text-orange-200/80">
            <li>About</li><li>Process</li><li>Careers</li><li>Blog</li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold mb-4 text-white">Contact</h4>
          <ul className="space-y-3 text-sm text-orange-200/80">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-amber-400" />{COMPANY.phone}</li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-amber-400" />{COMPANY.email}</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-amber-400" />{COMPANY.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-orange-900 py-5 text-center text-xs text-orange-300/60">
        © {new Date().getFullYear()} Inpace Power. All rights reserved.
      </div>
    </footer>
  );
}
